import { Close as CloseIcon } from '@mui/icons-material'
import { Box, CircularProgress, DialogTitle, IconButton, Stack, Tooltip } from '@mui/material'
import { useFormContext } from 'react-hook-form'

const closeButtonTooltip = 'Close — Esc'

export const ActionDrawerTitle = ({
    title,
    onClose,
    loading,
}: {
    title: string
    loading?: boolean
    onClose?: () => void
}) => {
    const isSubmitting = useFormContext()?.formState.isSubmitting
    const showLoading = loading || isSubmitting

    return (
        <Box>
            <Stack direction="row" justifyContent="space-between">
                <DialogTitle sx={{ m: 0, p: 0 }}>{title}</DialogTitle>
                {showLoading && <CircularProgress size={32} />}
                {onClose && !showLoading && (
                    <Tooltip title={closeButtonTooltip}>
                        <IconButton
                            onClick={onClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 12,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Tooltip>
                )}
            </Stack>
        </Box>
    )
}
